/* ZUBISTA — "THE PHARMACIE" Shopify theme front-end logic.
   Adapted from the static app.js: keeps nav / mobile-menu / reveal /
   focus-trap / drawer / variant selection, but the cart is the live
   Shopify AJAX cart (/cart/add.js, /cart.js, /cart/change.js). */
(function () {
  "use strict";
  document.documentElement.classList.add("js");
  var reduce = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches);
  var hoverable = !!(window.matchMedia && window.matchMedia("(hover:hover)").matches);

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, "${{amount}}");
    }
    return "$" + (Number(cents) / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
    });
  }

  /* ===== DIALOG ACCESSIBILITY (focus trap + restore + inert) ===== */
  var openDialogEl = null, lastFocus = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function focusables(c) {
    if (!c) return [];
    return Array.prototype.slice.call(c.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null || el.getClientRects().length;
    });
  }
  function focusFirst(c) { var f = focusables(c); if (f.length) f[0].focus(); }
  function trapTab(e, c) {
    var f = focusables(c); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openDialog(el, trigger) {
    if (!el) return;
    lastFocus = trigger || document.activeElement;
    openDialogEl = el; el.removeAttribute("inert"); focusFirst(el);
  }
  function restoreDialog() {
    var d = document.getElementById("cart-drawer"), mm = document.getElementById("mobile-menu");
    if (d && !d.classList.contains("open")) d.setAttribute("inert", "");
    if (mm && !mm.classList.contains("open")) mm.setAttribute("inert", "");
    openDialogEl = null;
    if (lastFocus && typeof lastFocus.focus === "function") { try { lastFocus.focus(); } catch (e) {} lastFocus = null; }
  }

  /* ===== TOAST ===== */
  var toastEl;
  function toast(msg) {
    toastEl = document.getElementById("toast");
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "toast"; toastEl.setAttribute("role", "status"); toastEl.setAttribute("aria-live", "polite"); toastEl.setAttribute("aria-atomic", "true"); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<svg width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>' + esc(msg);
    toastEl.classList.add("show"); clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove("show"); }, 3200);
  }

  /* ===== AJAX CART ===== */
  function updateBadge(count, bump) {
    var tgl = document.getElementById("cart-toggle");
    if (tgl) tgl.setAttribute("aria-label", count > 0 ? ("Open cart, " + count + " item" + (count === 1 ? "" : "s")) : "Open cart");
    var b = document.getElementById("cart-badge"); if (!b) return;
    b.textContent = count; b.classList.toggle("show", count > 0); b.setAttribute("aria-hidden", "true");
    if (bump && count > 0) { b.classList.remove("bump"); void b.offsetWidth; b.classList.add("bump"); }
  }

  function renderCart(cart) {
    var body = document.getElementById("cart-body"), foot = document.getElementById("cart-foot");
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="cart-empty">' +
        '<svg width="44" height="44" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M6 6h15l-1.5 9h-12z"/><path d="M6 6L5 2H2"/><circle cx="9" cy="20" r="1.6"/><circle cx="18" cy="20" r="1.6"/></svg>' +
        '<p>Your cart is empty.</p><a class="btn btn-coral btn-block" href="/collections/all" style="margin-top:16px">Start shopping</a></div>';
      if (foot) foot.style.display = "none";
      return;
    }
    body.innerHTML = cart.items.map(function (l, i) {
      var line = i + 1;
      var img = l.image ? l.image : "";
      var variantLabel = (l.variant_title && l.variant_title.indexOf("Default") < 0) ? '<span class="cvar">' + esc(l.variant_title) + '</span>' : '';
      return '<div class="cline"><div class="pic"><img src="' + esc(img) + '" alt="' + esc(l.product_title) + '"></div>' +
        '<div class="cinfo"><span class="b">' + esc(l.vendor || "") + '</span>' +
        '<a class="t" href="' + esc(l.url) + '">' + esc(l.product_title) + '</a>' +
        variantLabel +
        '<div class="cline-bottom"><div class="cqty">' +
          '<button type="button" data-line-dec="' + line + '" aria-label="Decrease">−</button>' +
          '<span>' + l.quantity + '</span>' +
          '<button type="button" data-line-inc="' + line + '" aria-label="Increase">+</button></div>' +
        '<span class="price">' + money(l.final_line_price) + '</span></div>' +
        '<button class="rm" type="button" data-line-rm="' + line + '">Remove</button></div></div>';
    }).join("");
    if (foot) { foot.style.display = ""; var st = document.getElementById("cart-subtotal"); if (st) st.textContent = money(cart.total_price); }
  }

  function fetchCart(cb) {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); updateBadge(cart.item_count, false); if (cb) cb(cart); })
      .catch(function () {});
  }

  function addToCart(id, qty, opts) {
    qty = qty || 1; opts = opts || {};
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: id, quantity: qty })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      fetchCart(function (cart) { updateBadge(cart.item_count, true); });
      if (!opts.silent) openCart();
    }).catch(function (e) {
      toast((e && e.description) ? e.description : "Could not add to cart.");
    });
  }

  function changeLine(line, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); updateBadge(cart.item_count, false); })
      .catch(function () {});
  }

  function openCart() {
    var d = document.getElementById("cart-drawer"), o = document.getElementById("overlay");
    if (d) { d.classList.add("open"); if (o) o.classList.add("show"); document.body.style.overflow = "hidden"; openDialog(d, document.getElementById("cart-toggle")); }
  }
  function closeCart() { var d = document.getElementById("cart-drawer"); if (d) d.classList.remove("open"); hideOverlayIfIdle(); }
  function closeMobile() { var mm = document.getElementById("mobile-menu"); if (mm) mm.classList.remove("open"); var t = document.getElementById("nav-toggle"); if (t) t.setAttribute("aria-expanded", "false"); hideOverlayIfIdle(); }
  function hideOverlayIfIdle() {
    var d = document.getElementById("cart-drawer"), mm = document.getElementById("mobile-menu");
    var open = (d && d.classList.contains("open")) || (mm && mm.classList.contains("open"));
    if (!open) { var o = document.getElementById("overlay"); if (o) o.classList.remove("show"); document.body.style.overflow = ""; restoreDialog(); }
  }

  /* ===== CHROME (delegated events for cart toggle, drawer, add buttons) ===== */
  function initChrome() {
    var tgl = document.getElementById("cart-toggle");
    if (tgl) tgl.addEventListener("click", function () { openCart(); });
    var cc = document.getElementById("cart-close");
    if (cc) cc.addEventListener("click", closeCart);
    var ov = document.getElementById("overlay");
    if (ov) ov.addEventListener("click", function () { closeCart(); closeMobile(); });

    /* product-card add-to-cart (single-variant cards) submit via AJAX */
    document.addEventListener("submit", function (e) {
      var f = e.target.closest("[data-card-add]");
      if (f) {
        e.preventDefault();
        var id = f.querySelector('input[name="id"]');
        if (id) addToCart(id.value, 1);
        return;
      }
      var pf = e.target.closest("[data-product-form]");
      if (pf) {
        e.preventDefault();
        var vid = pf.querySelector("#variant-id");
        var q = pf.querySelector("#qty");
        var qty = q ? (parseInt(q.value, 10) || 1) : 1;
        if (vid) addToCart(vid.value, qty);
        return;
      }
    });

    /* drawer line qty controls */
    document.addEventListener("click", function (e) {
      var dec = e.target.closest("[data-line-dec]");
      if (dec) { var l = parseInt(dec.getAttribute("data-line-dec"), 10); var span = dec.parentNode.querySelector("span"); var cur = span ? parseInt(span.textContent, 10) : 1; changeLine(l, Math.max(0, cur - 1)); return; }
      var inc = e.target.closest("[data-line-inc]");
      if (inc) { var li = parseInt(inc.getAttribute("data-line-inc"), 10); var span2 = inc.parentNode.querySelector("span"); var cur2 = span2 ? parseInt(span2.textContent, 10) : 1; changeLine(li, cur2 + 1); return; }
      var rm = e.target.closest("[data-line-rm]");
      if (rm) { changeLine(parseInt(rm.getAttribute("data-line-rm"), 10), 0); return; }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { closeCart(); closeMobile(); }
      else if (e.key === "Tab" && openDialogEl) { trapTab(e, openDialogEl); }
    });

    fetchCart();
  }

  /* ===== NAV / MOBILE MENU / NEWSLETTER ===== */
  function initNav() {
    var toggle = document.getElementById("nav-toggle"), menu = document.getElementById("mobile-menu");
    if (toggle && menu) {
      menu.setAttribute("role", "dialog"); menu.setAttribute("aria-modal", "true"); menu.setAttribute("aria-label", "Menu"); menu.setAttribute("inert", "");
      toggle.setAttribute("aria-expanded", "false"); toggle.setAttribute("aria-controls", "mobile-menu"); toggle.setAttribute("aria-haspopup", "dialog");
      toggle.addEventListener("click", function () { menu.classList.add("open"); document.body.style.overflow = "hidden"; toggle.setAttribute("aria-expanded", "true"); openDialog(menu, toggle); });
      var close = document.getElementById("mm-close"); if (close) close.addEventListener("click", closeMobile);
      menu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", closeMobile); });
    }
  }

  /* ===== REVEAL (slide-in-left) ===== */
  function initReveal() {
    var els = document.querySelectorAll("[data-reveal],[data-reveal-stagger]");
    if (!("IntersectionObserver" in window) || reduce) { Array.prototype.forEach.call(els, function (el) { el.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.hasAttribute("data-reveal-stagger")) {
          Array.prototype.slice.call(el.children).forEach(function (ch, i) { ch.style.transitionDelay = (i * 40) + "ms"; });
        }
        el.classList.add("in"); io.unobserve(el);
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* ===== PDP: gallery thumbs, zoom, qty, variant selection ===== */
  function initProduct() {
    var form = document.getElementById("product-form");
    if (!form) return;

    /* thumbnails */
    var thumbs = document.getElementById("thumbs");
    if (thumbs) thumbs.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-src]"); if (!b) return;
      var mi = document.getElementById("main-img"); if (mi) mi.src = b.getAttribute("data-src");
      thumbs.querySelectorAll("button").forEach(function (x) { x.classList.remove("active"); });
      b.classList.add("active");
    });

    /* hover zoom */
    var zoom = document.getElementById("zoom"), mimg = document.getElementById("main-img");
    if (zoom && mimg && !reduce && hoverable) {
      zoom.addEventListener("mousemove", function (e) {
        var r = zoom.getBoundingClientRect();
        mimg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
        mimg.style.transform = "scale(1.6)";
      });
      zoom.addEventListener("mouseleave", function () { mimg.style.transform = "scale(1)"; });
    }

    /* qty stepper */
    var qty = document.getElementById("qty");
    var qm = document.getElementById("q-minus"), qp = document.getElementById("q-plus");
    if (qm && qty) qm.addEventListener("click", function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (qp && qty) qp.addEventListener("click", function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

    /* variant selection */
    var dataEl = document.querySelector("[data-variant-json]");
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionGroups = Array.prototype.slice.call(form.querySelectorAll(".opt-row"));
    var selected = optionGroups.map(function (g) {
      var on = g.querySelector(".opt.is-on") || g.querySelector(".opt");
      return on ? on.getAttribute("data-opt-value") : null;
    });

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < selected.length; j++) {
          if (v.options[j] !== selected[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function refresh() {
      var v = findVariant();
      var vid = document.getElementById("variant-id");
      var priceEl = document.getElementById("pdp-price");
      var addBtn = document.getElementById("add-cart");
      var stockEl = document.getElementById("pdp-stock");
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; }
        if (stockEl) stockEl.textContent = "Unavailable";
        return;
      }
      if (vid) vid.value = v.id;
      if (priceEl) {
        var html = '<span class="now" data-price>' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
          html += '<span class="was" data-compare>' + money(v.compare_at_price) + '</span><span class="save" data-save>Save ' + pct + '%</span>';
        }
        priceEl.innerHTML = html;
      }
      if (v.featured_image) { var mi = document.getElementById("main-img"); if (mi) mi.src = v.featured_image; }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to cart" : "Sold out";
      }
      if (stockEl) stockEl.textContent = v.available ? "In stock · ships 1–2 days" : "Sold out";
    }

    optionGroups.forEach(function (g) {
      g.addEventListener("click", function (e) {
        var b = e.target.closest("[data-opt-value]"); if (!b) return;
        var idx = parseInt(b.getAttribute("data-opt-index"), 10);
        selected[idx] = b.getAttribute("data-opt-value");
        g.querySelectorAll(".opt").forEach(function (x) {
          var on = x === b;
          x.classList.toggle("is-on", on);
          x.setAttribute("aria-pressed", on ? "true" : "false");
        });
        refresh();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initChrome(); initNav(); initReveal(); initProduct();
  });

  window.ZB = { money: money, addToCart: addToCart, openCart: openCart, fetchCart: fetchCart };
})();
